import {Component, Injector, OnInit} from '@angular/core';
import { MultilingualData } from '@clients/member-direct/translation';
import { BaseElement } from 'libs/member-direct/surveys/src/lib/base-element.abstract';
import { Observable } from 'rxjs';
import {isObject} from '@clients/shared/utilities';
import { selectFooter } from '../../+state';
import { select } from '@ngrx/store';

@Component({
    selector: 'member-direct-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends BaseElement implements OnInit {
    public footer: Observable<MultilingualData<string>>;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.footer = this.store.pipe(select(selectFooter));
    }

    /**
     * Returns true if footer is defined, not null,
     * not a string and not an array and has at least
     * one defined language as a key.
     */
    public hasFooter(footer: MultilingualData<string>): boolean {
        if (!footer || typeof footer === 'symbol' || !isObject(footer, true)) return false;

        return Object.keys(footer).length > 0;
    }
}
